import {computed} from 'vue';
import {usePage} from '@inertiajs/vue3';

export const useLocales = () => {
  // Convert locales from an array to an object
  const locales = computed(() => {
    return usePage().props.locales.reduce((acc, locale) => {
      return {
        ...acc,
        [locale.code]: locale.name,
      };
    }, {});
  });

  const currentLocale = computed(() => {
    return usePage().props.currentLocale;
  });

  const localeRoute = (name, params = {}) => {
    const locale = currentLocale.value

    delete params['lang']

    if (locale !== 'en') {
      params['lang'] = locale
    }

    return route(name, params)
  }

  return {locales, currentLocale, localeRoute};
};
